var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { numberSlotLimit } from "@/components/forms/components/utils";
import { useLayout, usePopup } from "@/hooks/layout";
import { useAppSelector } from "@/hooks/store";
import { slotDirection } from "@/utils/funcs";
import { useLogger } from "@/utils/loggerService";
import { SlotDirection } from "@/utils/types/layout";
import { faCirclePlus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useParams } from "react-router-dom";
export default function (_a) {
    var _this = this;
    var _b;
    var to = _a.to;
    var showPopup = usePopup().showPopup;
    var addWidget = useLayout().addWidget;
    var logger = useLogger().logger;
    var isVertical = slotDirection(to) === SlotDirection.VERTICAL;
    var isHorizontal = !isVertical;
    var _c = useParams(), module = _c.module, action = _c.action;
    var slots = useAppSelector(function (state) { return state.layout.slots; });
    var widgetsInThisSlot = ((_b = slots[to]) === null || _b === void 0 ? void 0 : _b.widgets) || [];
    /*const totalColSpan = widgetsInThisSlot
      .filter((w) => w.slot === to && !w.meta?.pinned)
      .reduce((sum, w) => sum + (w?.payload?.width ?? 1), 0);*/
    var totalColSpan = widgetsInThisSlot
        .filter(function (w) { return w.slot === to; })
        .reduce(function (sum, w) { var _a, _b; return sum + (!((_a = w.meta) === null || _a === void 0 ? void 0 : _a.pinned) ? (_b = w === null || w === void 0 ? void 0 : w.payload) === null || _b === void 0 ? void 0 : _b.width : 1); }, 0);
    //console.log("widgetsInThisSlot=", to, totalColSpan);
    var checkLimitSlot = totalColSpan >= numberSlotLimit;
    return (_jsx("div", __assign({ className: "".concat(isVertical ? "w-full" : "h-full", " flex flex-none items-center justify-center") }, { children: _jsx("button", __assign({ title: checkLimitSlot ? "4 widgets maximum in this slot" : "Add a widget", className: "transition-all w-full h-full p-1 opacity-[0.75] hover:opacity-100 hover:bg-[color:var(--color-brand-neutral-50)] bg-[color:var(--color-brand-neutral-100)] transition-all\"", role: "button", "aria-description": "Ajout de widget \u00E0 l'emplacement ".concat(to), tabIndex: 0, onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, widget, newWidget;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localStorage.setItem("direction", JSON.stringify(slotDirection(to)));
                            return [4 /*yield*/, showPopup({
                                    type: "widget/selector",
                                    payload: {
                                        direction: slotDirection(to),
                                        slot: to,
                                    },
                                })];
                        case 1:
                            _a = _b.sent(), widget = _a.widget, newWidget = _a.reason;
                            if (newWidget && newWidget.type) {
                                logger.debug("[ADD_WIDGET]- Ajout widget", newWidget);
                                addWidget(__assign(__assign({}, newWidget), { slot: to, actionUrl: action ? action : "index", module: module }));
                            }
                            else {
                                logger.debug("[ADD_WIDGET]- Ajout annulé");
                            }
                            return [2 /*return*/];
                    }
                });
            }); } }, { children: _jsx(FontAwesomeIcon, { icon: faCirclePlus, className: "w-8 h-8 text-[var(--color-brand-info-700)]" }) })) })));
}
